const Error404 = () => {
  return (
    <div>404 - Siden kan ikke vises</div>
  )
}

export default Error404